// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.light::before {
    content: "light";
    position: absolute;
    color: "#ffffff";
    filter: blur(5px);
}

.light {
    color: "#ffffff";
    position: relative;
}

/* .light::after {
    content: "light";
    position: absolute;
    width: 30vh;
    height: 1vh;
    background: radial-gradient(closest-side ellipse at 45% center,
            hsl(4 20% 90% / 80%) 0%,
            hsl(4 10% 70% / 30%) 30%,
            transparent 95%);
} */`, "",{"version":3,"sources":["webpack://./src/css/title.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;;;;;;;;GASG","sourcesContent":[".light::before {\n    content: \"light\";\n    position: absolute;\n    color: \"#ffffff\";\n    filter: blur(5px);\n}\n\n.light {\n    color: \"#ffffff\";\n    position: relative;\n}\n\n/* .light::after {\n    content: \"light\";\n    position: absolute;\n    width: 30vh;\n    height: 1vh;\n    background: radial-gradient(closest-side ellipse at 45% center,\n            hsl(4 20% 90% / 80%) 0%,\n            hsl(4 10% 70% / 30%) 30%,\n            transparent 95%);\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
